module.exports = __webpack_public_path__ + "media/strong.188fbf03.mp3";